import { GoogleMap } from 'components/map';
import style from './index.module.scss';
import { Form } from 'antd';
import { FormInstance } from 'antd/lib';
import { useOutletContext } from 'react-router-dom';

import { useCallback } from 'react';
import useSetLocation from 'hooks/useSetLocation';
import { useSelector } from 'react-redux';
import { WORKER_STATUS } from 'api';

export const Step3CompalteProfile = () => {
  const form = useOutletContext() as FormInstance;
  const { click } = useSetLocation();
  const userStatus = useSelector((state: any) => state.profile?.data?.state);
  const onChangeMap = useCallback(
    (data: any) => {
      form.setFieldsValue({ locationLat: data.lat, locationLong: data.lng });
    },
    [form],
  );

  return (
    <div className={style.map}>
      <GoogleMap
        notEditable={WORKER_STATUS.waitingRevision === userStatus}
        onClick={onChangeMap}
        newCenter={click}
      />
      <img
        className={style.market}
        src="../../../assets/icon/marker.svg"
        alt=""
      />
      <Form
        disabled={WORKER_STATUS.waitingRevision === userStatus}
        layout={'vertical'}
        form={form}
      >
        <Form.Item hidden name="locationLat" rules={[{ required: true }]} />
        <Form.Item hidden name="locationLong" rules={[{ required: true }]} />
      </Form>
    </div>
  );
};
